import React from 'react';
import ContactUs from '../../../Shared/ContactUs/ContactUs';
import FundBanner from '../FundBanner/FundBanner';
import FundCanadaDetails from '../FundCanadaDetails/FundCanadaDetails';

const FundCanada = () => {
    return (
        <div>
            
            <FundBanner></FundBanner>
            <FundCanadaDetails></FundCanadaDetails>
            
        </div>
    );
};

export default FundCanada;